export const release = "04-NOV-26 04:45:58";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
